import { Action } from 'redux';
import { ErrorWrapper } from 'store/base';

export const REDUCER_NAME__PARTNERS = 'partners';

export interface PartnerListReduxState {
  type?: string;
  loading: boolean;
  errorWrapper?: ErrorWrapper;
}

const defaultState: PartnerListReduxState = {
  loading: false,
};

export default (
  state: PartnerListReduxState = defaultState,
  action: Action,
): PartnerListReduxState => {
  return state;
};
